import { ChangeDetectionStrategy, Component, HostBinding, Input, input } from '@angular/core';
import { TooltipModule } from '@bazis/shared/components/web/tooltip/tooltip.module';
import { ChipModule } from '@bazis/shared/components/web/chip/chip.module';
import { ColorDirective } from '@bazis/shared/directives/color.directive';
import { CommonModule } from '@angular/common';
import { IconModule } from '../web/icon/icon.module';
import { SizeRange } from '@bazis/shared/models/base.types';
import { TooltipSettings } from '@bazis/form/models/form-element.types';

@Component({
    selector: 'bazis-status',
    templateUrl: './status.component.html',
    imports: [TooltipModule, ChipModule, ColorDirective, CommonModule, IconModule],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class StatusComponent {
    readonly label = input<string>();

    readonly tooltipText = input<string>();

    readonly color = input<string>();

    readonly size = input<SizeRange>();
    //                       mini  compact  regular  large  huge  giant
    // readonly size = input<'xs' | 'small'>('');

    readonly hasDecor = input<boolean>(false);

    readonly fill = input<'clear' | 'outline' | 'solid'>();

    readonly isStaticTooltip = input<boolean>(false);

    readonly hasTooltip = input<boolean>(true);

    readonly iconStart = input<string>();

    readonly iconEnd = input<string>();

    // настройки отображения и работы тултипа
    readonly tooltipPlacement = input<
        | 'auto'
        | 'auto-start'
        | 'auto-end'
        | 'top'
        | 'top-start'
        | 'top-end'
        | 'bottom'
        | 'bottom-start'
        | 'bottom-end'
        | 'right'
        | 'right-start'
        | 'right-end'
        | 'left'
        | 'left-start'
        | 'left-end'
    >('top');

    // смещение тултипа [x, y]
    readonly tooltipOffset = input<[number, number]>([0, 4]);

    @HostBinding('class') get statusStyle() {
        return {
            'bazis-status_nodecor': !this.hasDecor(),
            'bh-pointer': this.hasTooltip(),
        };
    }
}
